export default __webpack_public_path__ + "static/RobotoMono-600-ff2c5c919a01e9ddda8532d1a8bbb4c9.woff2";